import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Financieel, {
  isVisible: (settings: EnvironmentSettings) => settings.isFinancieel,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Financieel,
    title: 'Financieel',
    url: '/content/rapportage?fin=1',
    iconclass: 'fas fa-coins',
  }),
});
